import { Route, Routes } from "react-router-dom";
import { DocsShell } from "./components/DocsShell";
import { OverviewPage } from "./pages/OverviewPage";
import { PrinciplesPage } from "./pages/foundations/PrinciplesPage";
import { TokensPage } from "./pages/foundations/TokensPage";
import { ColorPage } from "./pages/foundations/ColorPage";
import { TypographyPage } from "./pages/foundations/TypographyPage";
import { LayoutPage } from "./pages/foundations/LayoutPage";
import { SpacingPage } from "./pages/foundations/SpacingPage";
import { RadiusPage } from "./pages/foundations/RadiusPage";
import { ElevationPage } from "./pages/foundations/ElevationPage";
import { IconographyPage } from "./pages/foundations/IconographyPage";
import { MotionPage } from "./pages/foundations/MotionPage";
import { StatesPage } from "./pages/components/StatesPage";
import { ButtonsPage } from "./pages/components/ButtonsPage";
import { FormsPage } from "./pages/components/FormsPage";
import { TablesPage } from "./pages/components/TablesPage";
import { CardsPage } from "./pages/components/CardsPage";
import { BadgesPage } from "./pages/components/BadgesPage";
import { NavigationPage } from "./pages/components/NavigationPage";
import { OverlaysPage } from "./pages/components/OverlaysPage";
import { FeedbackPage } from "./pages/components/FeedbackPage";
import { AsyncPage } from "./pages/components/AsyncPage";
import { DomainPage } from "./pages/components/DomainPage";
import { PagesPatternPage } from "./pages/patterns/PagesPatternPage";
import { SearchPatternPage } from "./pages/patterns/SearchPatternPage";
import { ResponsivePage } from "./pages/patterns/ResponsivePage";
import { AccessibilityPage } from "./pages/patterns/AccessibilityPage";
import { ContentPage } from "./pages/patterns/ContentPage";
import { PermissionsPage } from "./pages/patterns/PermissionsPage";
import { InventoryPage } from "./pages/governance/InventoryPage";
import { ImplementationPage } from "./pages/governance/ImplementationPage";
import { MigrationPage } from "./pages/governance/MigrationPage";
import { AuditPage } from "./pages/governance/AuditPage";

export function App() {
    return (
        <Routes>
            <Route element={<DocsShell />}>
                <Route index element={<OverviewPage />} />
                <Route path="foundations/principles" element={<PrinciplesPage />} />
                <Route path="foundations/tokens" element={<TokensPage />} />
                <Route path="foundations/color" element={<ColorPage />} />
                <Route path="foundations/typography" element={<TypographyPage />} />
                <Route path="foundations/layout" element={<LayoutPage />} />
                <Route path="foundations/spacing" element={<SpacingPage />} />
                <Route path="foundations/radius" element={<RadiusPage />} />
                <Route path="foundations/elevation" element={<ElevationPage />} />
                <Route path="foundations/iconography" element={<IconographyPage />} />
                <Route path="foundations/motion" element={<MotionPage />} />
                <Route path="components/states" element={<StatesPage />} />
                <Route path="components/buttons" element={<ButtonsPage />} />
                <Route path="components/forms" element={<FormsPage />} />
                <Route path="components/tables" element={<TablesPage />} />
                <Route path="components/cards" element={<CardsPage />} />
                <Route path="components/badges" element={<BadgesPage />} />
                <Route path="components/navigation" element={<NavigationPage />} />
                <Route path="components/overlays" element={<OverlaysPage />} />
                <Route path="components/feedback" element={<FeedbackPage />} />
                <Route path="components/async" element={<AsyncPage />} />
                <Route path="components/domain" element={<DomainPage />} />
                <Route path="patterns/pages" element={<PagesPatternPage />} />
                <Route path="patterns/search" element={<SearchPatternPage />} />
                <Route path="patterns/responsive" element={<ResponsivePage />} />
                <Route path="patterns/accessibility" element={<AccessibilityPage />} />
                <Route path="patterns/content" element={<ContentPage />} />
                <Route path="patterns/permissions" element={<PermissionsPage />} />
                <Route path="governance/inventory" element={<InventoryPage />} />
                <Route path="governance/implementation" element={<ImplementationPage />} />
                <Route path="governance/migration" element={<MigrationPage />} />
                <Route path="governance/audit" element={<AuditPage />} />
            </Route>
        </Routes>
    );
}
